export default __webpack_public_path__ + "static/corner-ec75487fead1849c8112414074741dc0.png";